import adminApiClient from "@/lib/api/admin-api-client";
import { env } from "@/config/env";

export interface AdminForgotPasswordRequest {
  email: string;
}

export interface AdminForgotPasswordResponse {
  message: string;
}

export async function requestAdminPasswordReset(
  payload: AdminForgotPasswordRequest,
) {
  const { data } = await adminApiClient.post<AdminForgotPasswordResponse>(
    env.adminAuthForgotPasswordPath,
    payload,
  );
  return data;
}
